import { Injectable } from "@angular/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { Observable } from "rxjs/Observable";

import swal from "sweetalert2";
import { error } from "jquery";
import { AppLoaderService } from "../../services/app-loader/app-loader.service";
import { config } from "../../config";

@Injectable()
export class AuthService {
  private tokenCache: any = null;
  private tokenExpiryTime = 0;

  private licenseTokenCache = new Map<number, any>();
  constructor(private http: Http, private appLoaderService: AppLoaderService) {}
  public access_token(): Observable<any> {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      "No-Auth": "True",
    });

    let options = new RequestOptions({ headers: headers });
    let data =
      "grant_type=client_credentials&scope=LicenseandActivationAPIAccess&" +
      "client_secret=54012654468d382b6f75159d7fd6fe75&client_id=14";

    return this.http
      .post(config.TokenGenerationUrl + "connect/token", data, options)
      .map((res) => res.json())
      .catch((err) => {
        if (err.status == 404) {
          swal.fire(
            "Warning",
            "The Client was unable to connect the API " + err.url,
            "warning"
          );
          this.appLoaderService.close();
        } else if (err.status == 500) {
          swal.fire(
            "Warning",
            "The server encountered an unexpected condition that prevented it from fulfilling the request.",
            "warning"
          );
          this.appLoaderService.close();
        } else if (err.status == 401) {
          swal.fire("Warning", "UnAuthorized Token..!", "warning");
          this.appLoaderService.close();
        } else {
          swal.fire(
            "Warning",
            "Something went wrong! Please contact administrator..!",
            "warning"
          );
          this.appLoaderService.close();
        }
        return Observable.throw(err);
      });
  }
  public access_token_licenseFreyalCode(
    client_id: number,
    client_secret: string
  ): Observable<any> {
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      "No-Auth": "True",
    });
    let options = new RequestOptions({ headers: headers });
    let body =
      "grant_type=client_credentials&scope=LicenseandActivationAPIAccess&client_secret=" +
      client_secret +
      "&client_id=" +
      client_id;
    return this.http
      .post(config.TokenGenerationUrl + "connect/token", body, options)
      .map((response) => response.json())
      .catch((error) => {
        if (error.status == 404) {
          swal.fire(
            "Warning",
            "The Client was unable to connect the API " + error.url,
            "warning"
          );
          this.appLoaderService.close();
        } else if (error.status == 500) {
          swal.fire(
            "Warning",
            "The server encountered an unexpected condition that prevented it from fulfilling the request.",
            "warning"
          );
          this.appLoaderService.close();
        } else if (error.status == 401) {
          swal.fire("Warning", "UnAuthorized Token..!", "warning");
          this.appLoaderService.close();
        } else {
          swal.fire(
            "Warning",
            "Something went wrong! Please contact administrator..!",
            "warning"
          );
          this.appLoaderService.close();
        }
        return Observable.throw(error);
      });
  }
  public access_token_license(
    client_id: number,
    client_secret: string
  ): Observable<any> {
    const cached = this.licenseTokenCache.get(client_id);

    // ✅ Return cached token if valid
    if (cached && Date.now() < cached.expiry) {
      return Observable.of(cached.token);
    }

    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json",
      "No-Auth": "True",
    });

    let options = new RequestOptions({ headers: headers });

    let body =
      "grant_type=client_credentials&scope=LicenseandActivationAPIAccess&" +
      "client_secret=" +
      client_secret +
      "&client_id=" +
      client_id;

    return this.http
      .post(config.TokenGenerationUrl + "connect/token", body, options)
      .map((response) => {
        const token = response.json();

        // ✅ Cache per product
        this.licenseTokenCache.set(client_id, {
          token: token,
          expiry: Date.now() + token.expires_in * 1000 - 60000,
        });

        return token;
      })
      .catch((err) => this.handleError(err));
  }

  private handleError(error: any) {
    if (error.status == 404) {
      swal.fire(
        "Warning",
        "The Client was unable to connect the API " + error.url,
        "warning"
      );
    } else if (error.status == 500) {
      swal.fire(
        "Warning",
        "The server encountered an unexpected condition that prevented it from fulfilling the request.",
        "warning"
      );
    } else if (error.status == 401) {
      swal.fire("Warning", "UnAuthorized Token..!", "warning");
    } else {
      swal.fire(
        "Warning",
        "Something went wrong! Please contact administrator..!",
        "warning"
      );
    }
    this.appLoaderService.close();
    return Observable.throw(error);
  }

  // public MicrosoftOAuthToken(){
  //     let headers=new Headers({
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //         'Access-Control-Allow-Origin':'*',
  //     });
  //     let options = new RequestOptions({ headers: headers });
  //     let body= "grant_type=client_credentials&client_id=1e3ed11e-f73a-4bc0-bfc8-625430dd6fae&client_secret=aZ38Q~imFd4U2w-WrbIzBh3IVDC44BIzdE8pNbDE&scope=https://api.businesscentral.dynamics.com/.default";
  //     return this.http.post(this.envService.microsoftOAuthUrl,body,options).map((response=>response.json())).catch(error=>
  //         {
  //             if (error.status == 404) {
  //                 swal.fire("Warning", "The Client was unable to connect the API " + error.url, 'warning');
  //             }
  //             else if (error.status == 500) {
  //                 swal.fire("Warning", "The server encountered an unexpected condition that prevented it from fulfilling the request.", "warning");
  //             }
  //             else if (error.status == 401) {
  //                 swal.fire("Warning", "UnAuthorized Token..!", "warning");
  //             }
  //             else {
  //                 swal.fire("Warning", "Something went wrong! Please contact administrator..!", "warning");
  //             }
  //             return Observable.throw(error);
  //         }
  //     )
  // }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/auth.service.ts